/* eslint-disable react/prop-types */
// @ts-nocheck
import React from 'react';
import { Box, Popover, TextField } from '@mui/material';
import ModelMetaDataSchemaTree from './ModelMetaDataSchemaTree';
import { SwalToast } from '.';

// eslint-disable-next-line react/prop-types

const ModelMetaDataSchemaTreeDropdown = ({
  name,
  label,
  placeholder,
  onNodeSelect,
  defaultValue,
  outputType,
  modelMetaDataSchema,
}) => {
  const ref = React.useRef();
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(defaultValue);

  /**
   * @function handleClose
   * @description to handle close
   * @returns {void}
   * @example handleClose()
   */
  const handleClose = () => {
    if (value === 'undefined / undefined') {
      SwalToast({
        icon: 'error',
        title: 'Please select node. Only section selection is not allowed.',
      });
      setOpen(false);
    } else setOpen(false);
  };

  const handleNodeClick = (sec, attr) => {
    onNodeSelect(sec, attr);
    setValue(`${sec?.section_name} / ${attr?.label}`);
    handleClose();
  };

  return (
    <>
      <TextField
        label={label}
        placeholder={placeholder}
        name={name}
        inputProps={{ readOnly: true }}
        value={value}
        onClick={() => {
          setOpen(true);
        }}
        ref={ref}
      />
      <Popover
        open={open}
        anchorEl={ref?.current}
        onClose={() => {
          handleClose();
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        keepMounted={true}
      >
        <Box sx={{ minWidth: '200px', width: '100%' }} p={2}>
          <Box>
            {
              // eslint-disable-next-line react/prop-types
              modelMetaDataSchema ? (
                <Box
                  sx={{
                    width: 'auto',
                    height: 250,
                    overflow: 'scroll',
                  }}
                >
                  <ModelMetaDataSchemaTree
                    modelMetaDataSchema={modelMetaDataSchema}
                    handleNodeClick={handleNodeClick}
                    nodeTypesToEnable={[outputType?.toLowerCase()]}
                  />
                </Box>
              ) : (
                <Box textAlign="center">
                  No section available in this schema.
                </Box>
              )
            }
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default ModelMetaDataSchemaTreeDropdown;
